export const scrollToBottom = ({ current }, options) => {
  current?.scrollIntoView({
    block: "end",
    inline: "nearest",
    ...options,
  });
};

export default scrollToBottom;
